import VimeoPlayer from '@vimeo/player';
import YouTubePlayer from 'youtube-player'

$.fn.VideoAutoplay = function() {
  let self = this

  self.find('.vimeo-video').each(function() {
    let vimeo_video = $(this)
    var options = {
      url: $(this).attr('data-my-vimeo-url'),
      muted: 1,
      loop: 1,
      autoplay: true,
      controls: false,
    };
    var videoPlayer = new VimeoPlayer($(this), options);
    videoPlayer.on('loaded', function() {
      var width = vimeo_video.find('iframe').attr('width')
      var height = vimeo_video.find('iframe').attr('height')
      vimeo_video.css('padding-top', height / width * 100 + '%')
    })
  })

  self.find('.youtube-video-wrapper').each(function() {
    let youtube_video_wrapper = $(this)
    let youtube_video = $(this).find('.youtube-video')
    var url = new URL(youtube_video.attr('data-my-youtube-url'));
    var video_id = url.searchParams.get("v");
    var options = {
      videoId: video_id,
      playerVars: {
        'autoplay': 1,
        'controls': 0,
        'loop': 1,
        'modestbranding' : 0,
        'showinfo' : 0,
        'rel' : 0,
      },
    }
    var youtubePlayer = YouTubePlayer(youtube_video.get(0), options);
    youtubePlayer.on('stateChange', function(event) {
      if (event.data === 1) { // playing
        var width = youtube_video_wrapper.find('iframe').attr('width')
        var height = youtube_video_wrapper.find('iframe').attr('height')
        youtube_video_wrapper.css('padding-bottom',  height / width * 100 + '%')
      }
      if (event.data === 0) { // ended
        youtubePlayer.playVideo();
      }
    });
    youtubePlayer.mute();
  })

  return function() {
    return self
  }()
}
